export default {
  name: 'SidePanel',
  data(){
    return {
      display:false,
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    value:{
      default:true
    },
    width:{
      default:61
    },
    loading:{
      type:Boolean,
      default:false
    },
    transfer:{
      type:Boolean,
      default:true
    },
    footerVisible:{
      type:Boolean,
      default:true
    },
    destroyOnClose:{
      type:Boolean,
      default:false
    }
  },
  watch:{
    value(val){
      if( val ){
        this.display = true
      }else{
        this.display = false
      }
    }
  },
  created() {
  },
  methods:{
   handleClose(){
    this.display = false
    this.$emit('input' , false)
   },
   renderContent(){
    const renderable = this.display || (!this.display && !this.destroyOnClose)
    if( renderable ){
      const { $scopedSlots } = this
      const bodyNode = $scopedSlots.default ? $scopedSlots.default() : null
      const footerNode = $scopedSlots.footer ? <div class="ft">{$scopedSlots.footer()}</div> : null
      return [bodyNode,footerNode]
    }else{
      return []
    }
   }
  },
  render(){
    const { $scopedSlots , title , renderContent} = this

    const slots = {
      header: () => {
        return <div class="hd-wrap">
          <strong>{title}</strong>
          <div class="hd">
            {$scopedSlots.header ? $scopedSlots.header() : null}
          </div>    
        </div>
      },
    }
    
    const hasFooter = !!$scopedSlots.footer
    return (
      <Drawer class={['sl-side-panel','scroll-y',hasFooter?'sl-side-panel-footer':null]} transfer={this.transfer} title={this.title} v-model={this.display} width={this.width} mask-closable={false} on-on-close={this.handleClose} scopedSlots={slots}>
        {renderContent()}
      </Drawer>
    )
  }
}
